import { GET_RESUMEN_CIERRE_DIARIO } from '../constants/action_types';

const initialState = { resumen: [], isLoading: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_RESUMEN_CIERRE_DIARIO:
        
            return {
                resumen: [],
                isLoading: true
            };

        case GET_RESUMEN_CIERRE_DIARIO + "_SUCCESS":
        
            return {
                resumen: action.payload.data.resumen,
                isLoading: false
            };

        default:

            return state;
    };
};